module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUBAMAAABohZD3AAAAKlBMVEUAAAAcqXExsX9XV1eb2cHH6tzI6t3M7N/OESbfYnDp9/H9/v7+//7///+iqyWzAAAAPElEQVQY02PoQAUM1ObPRAUMd4HgzF04CeaHgfmpMP4VJV84CeLfFtwLJ0H8W+Vr4SRYPxJgMEYFDDQGAN7ogqDbnYIeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/sy.png
// module id = 389
// module chunks = 0